//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    name: 'ThirdPartyLoginButtons',

    methods: {

        // handle oauth click
        oauth(provider){
            if(provider == 'insta' || provider == 'github'){
                alert(provider + ' not ready yet')
                return
            }

            axios.post('/api/auth/provider/' + provider)
                  .then( r => {
                      let url = r.data.url

                      if(url){
                          // const newWindow = openWindow('', 'Gkiokan.NET OAuth Login')
                          // newWindow.location.href = url
                          window.open(url)
                      }

                  })
                  .catch(e => console.log(e.response) )
        }
    }
}
